// src/services/cartApi.js
import api from "../api";

class CartApi {
  constructor() {
    this.baseUrl = "/operation";
  }

  // دریافت سبد خرید جاری
  async getCart() {
    try {
      const response = await api.get(`operation/cart/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching cart:", error);
      throw error;
    }
  }

  // افزودن آیتم به سبد خرید
  async addToCart(productId, quantity = 1) {
    try {
      const response = await api.post(`operation/cart/add_item/`, {
        product_id: productId,
        quantity: quantity,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding to cart:", error);
      throw error;
    }
  }

  // بروزرسانی تعداد آیتم
  async updateQuantity(itemId, quantity) {
    try {
      const response = await api.post(`operation/cart/update_quantity/`, {
        item_id: itemId,
        quantity: quantity,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating quantity:", error);
      throw error;
    }
  }

  // حذف آیتم از سبد خرید
  async removeItem(itemId) {
    try {
      const response = await api.post(`operation/cart/remove_item/`, {
        item_id: itemId,
      });
      return response.data;
    } catch (error) {
      console.error("Error removing item:", error);
      throw error;
    }
  }

  // خالی کردن سبد خرید
  async clearCart() {
    try {
      const response = await api.post(`operation/cart/clear/`);
      return response.data;
    } catch (error) {
      console.error("Error clearing cart:", error);
      throw error;
    }
  }

  // اعتبارسنجی سبد خرید
  async validateCart() {
    try {
      const response = await api.get(`operation/cart/validate/`);
      return response.data;
    } catch (error) {
      console.error("Error validating cart:", error);
      throw error;
    }
  }
}

export const cartApi = new CartApi();